export const iconFontAwesomeMusicVideoHeadphonesSimple = (
	<i className="fa-solid fa-headphones-simple"></i>
);
